import {invoker, allPass} from 'ramda';
import {func} from 'prop-types';

const _userModel = Symbol('userModel');
const _debugModel = Symbol('debugModel');

class AppContext {
  constructor({userModel}) {
    this[_userModel] = userModel;
    this[_debugModel] = userModel.debugModel;
  }

  getAvailableTargets = () => this[_userModel].getAvailableTargetsJSON();

  isPackageTypeAllowed = packageType => this[_userModel].isPackageTypeAllowed(packageType);

  isAnyPackageTypeAllowed = packageTypes => this[_userModel].isAnyPackageTypeAllowed(packageTypes);

  getStations = () => this[_userModel].getStations();

  hasUserPermission = permission => this[_userModel].userHasAnyPermission(permission);

  hasUserPermissionSet = (permission, uuid) => this[_userModel].userHasPermissionSet(permission, uuid);

  hasGlobalPermissionSet = permissionSet => this[_userModel].userHasGlobalPermissionSet(permissionSet);

  hasAnyPermissionSet = permissionSet => this[_userModel].userHasAnyPermissionSet(permissionSet);

  getFeatureFlag = flag => this[_debugModel].getFeatureFlag(flag);

  getAllFeatureFlags = () => this[_debugModel].toJSON();

  setFeatureFlag = (flag, value = !this.getFeatureFlag(flag)) => this[_debugModel].setFeatureFlag(flag, value);

  getUserName = () => this[_userModel].get('user').username;
}

// static functions for easy composition

export const getStations = invoker(0, 'getStations');
export const getAvailableTargets = invoker(0, 'getAvailableTargets');
export const isPackageTypeAllowed = invoker(1, 'isPackageTypeAllowed');
export const isAnyPackageTypeAllowed = invoker(1, 'isAnyPackageTypeAllowed');
export const hasUserPermission = invoker(1, 'hasUserPermission');
export const hasUserPermissionSet = invoker(2, 'hasUserPermissionSet');
export const hasGlobalPermissionSet = invoker(1, 'hasGlobalPermissionSet');
export const hasAnyPermissionSet = invoker(1, 'hasAnyPermissionSet');
export const getFeatureFlag = invoker(1, 'getFeatureFlag');
export const getAllFeatureFlags = invoker(1, 'getAllFeatureFlags');
export const setFeatureFlag = invoker(2, 'setFeatureFlag');

// hasPermissionAndPackageType :: (String, String) -> AppContext -> Boolean
export const hasPermissionAndPackageType = (permissionSet, packageType) =>
  allPass([hasGlobalPermissionSet(permissionSet), isPackageTypeAllowed(packageType)]);

export const appContextShape = {
  getStations: func.isRequired,
  getAvailableTargets: func.isRequired,
  isPackageTypeAllowed: func.isRequired,
  isAnyPackageTypeAllowed: func.isRequired,
  hasUserPermissionSet: func.isRequired,
  hasGlobalPermissionSet: func.isRequired,
  hasAnyPermissionSet: func.isRequired,
  getFeatureFlag: func.isRequired,
  setFeatureFlag: func.isRequired,
  getAllFeatureFlags: func.isRequired,
};

export default AppContext;
